<div>
  <br />

  <h5><span class="material-symbols-outlined">help</span>{{ 'Vilken plattform använder du?' | translate }}</h5>
  <!-- SHOPIFY -->
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag säljer via Shopify' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <h5><span class="material-symbols-outlined">help</span>{{ 'Säljer du existerande motiv eller on-demand?' | translate }}</h5>

      <!-- SHOPIFY | EXISTING FILES -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag säljer redan existerande motiv' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <h5>{{ 'Hur många motiv rör det sig om?' | translate }}</h5>

          <!-- SHOPIFY | EXISTING FILES | FEW FILES -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag har endast ett fåtal motiv (färre än 50)' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <h5>{{ 'Hur stora är filerna?' | translate }}</h5>

              <!-- SHOPIFY | EXISTING FILES | FEW FILES | SMALL FILES -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'De är mindre än 30MB' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                  <ul>
                    <li>{{ 'Säkerställ att motiven har unika filnamn, och att filnamnen ej innehåller understreck(_).' | translate }}</li>
                    <li>{{ 'Ladda upp filerna via' | translate }}<a target="_blank"
                        [href]="globals.storeUrl('/posters', globals.storeSettings._id, true)"> <span
                          class="material-symbols-outlined">wall_art</span>{{ 'Produkter' | translate }}</a></li>
                    <li>
                      <ng-template [ngTemplateOutlet]="shopifyFileNameSKUMapping"></ng-template>
                    </li>
                  </ul>
                </div>
              </mat-expansion-panel>


              <!-- SHOPIFY | EXISTING FILES | FEW FILES | LARGE FILES -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'De är större än 30MB' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                  <ng-template [ngTemplateOutlet]="ftpInstructions"></ng-template>
                  <ng-template [ngTemplateOutlet]="shopifyFileNameSKUMapping"></ng-template>
                </div>
              </mat-expansion-panel>
            </div>
          </mat-expansion-panel>


          <!-- SHOPIFY | EXISTING FILES | MANY FILES -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag har många motiv (fler än 50)' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <ng-template [ngTemplateOutlet]="ftpInstructions"></ng-template>
              <ng-template [ngTemplateOutlet]="shopifyFileNameSKUMapping"></ng-template>
            </div>
          </mat-expansion-panel>

        </div>
      </mat-expansion-panel>

      <!-- SHOPIFY | ON DEMAND FILES -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Motiven skapas efter att en ny order inkommer' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <ul>
            <li>{{ 'Se till att Streckkoden(Barcode) på produktvarianterna i Shopify har följande format:' | translate }}<br />
              <i>{{ '010-BREDD-HÖJD-TYP-PAPPER' | translate }}</i>
              <br />
              <i>{{ '(TYP är 001 för poster och 002 för canvas)' | translate }}</i>
              <br />
              <i>{{ '(PAPPER är 001 för obestruket och 002 för bestruket)' | translate }}</i>
              <br />
              <br />
              <b>{{ 'Exempel:' | translate }}</b>
              <table class="styled fullwidth">
                <tr>
                  <th>{{ 'Produkt' | translate }}</th>
                  <th class="align-right">{{ 'Barcode' | translate }}</th>
                </tr>
                <tr>
                  <td>{{ '50x70cm poster på obestruket papper' | translate }}</td>
                  <th class="align-right">010-050-070-001-001</th>
                </tr>
                <tr>
                  <td>{{ '40x30cm poster på bestruket papper' | translate }}</td>
                  <th class="align-right">010-040-050-001-002</th>
                </tr>
                <tr>
                  <td>{{ '50x50cm canvas' | translate }}</td>
                  <th class="align-right">010-050-050-002-000</th>
                </tr>
                <tr>
                  <td>{{ '70x100cm canvas' | translate }}</td>
                  <th class="align-right">010-070-100-002-000</th>
                </tr>
              </table>
            </li>
            <li>{{ 'När en ny order inkommer så kan du ladda upp ditt motiv under' | translate }}<a target="_blank"
                [href]="globals.storeUrl('/orders', globals.storeSettings._id, true)"> <span
                  class="material-symbols-outlined">paid</span>{{ 'Ordrar' | translate }}</a>.
            </li>
            <li>{{ 'När filen är uppladdad så kommer den att bearbetas och skickas till print automatiskt.' | translate }}</li>
          </ul>
        </div>
      </mat-expansion-panel>

    </div>
  </mat-expansion-panel>


  <!-- WOOCOMMERCE -->
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag säljer via Wordpress(WooCommerce)' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <div>{{ 'Säkerställ att vi har installerat vårt Wordpress-plugin(ACE Ecommerce) åt er. Om så inte är fallet, kontakta oss på' | translate }}<a href="mailto:info@aceprintpartner.com">{{ 'info&#64;aceprintpartner.com' | translate }}</a>.
      </div>
      <br />
      <h5><span class="material-symbols-outlined">help</span>{{ 'Säljer du existerande motiv eller on-demand?' | translate }}</h5>

      <!-- WOOCOMMERCE | EXISTING FILES -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag säljer redan existerande motiv' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <h5>{{ 'Hur många motiv rör det sig om?' | translate }}</h5>

          <!-- WOOCOMMERCE | EXISTING FILES | FEW FILES -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag har endast ett fåtal motiv (färre än 50)' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <h5>{{ 'Hur stora är filerna?' | translate }}</h5>

              <!-- WOOCOMMERCE | EXISTING FILES | FEW FILES | SMALL FILES -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'De är mindre än 30MB' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                  <ul>
                    <li>{{ 'Säkerställ att motiven har unika filnamn, och att filnamnen ej innehåller understreck(_).' | translate }}</li>
                    <li>{{ 'Ladda upp filerna via' | translate }}<a target="_blank"
                        [href]="globals.storeUrl('/posters', globals.storeSettings._id, true)"> <span
                          class="material-symbols-outlined">wall_art</span>{{ 'Produkter' | translate }}</a></li>
                    <li>
                      <ng-template [ngTemplateOutlet]="wooCommerceFileNameSKUMapping"></ng-template>
                    </li>
                  </ul>
                </div>
              </mat-expansion-panel>


              <!-- WOOCOMMERCE | EXISTING FILES | FEW FILES | LARGE FILES -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'De är större än 30MB' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                  <ng-template [ngTemplateOutlet]="ftpInstructions"></ng-template>
                  <ng-template [ngTemplateOutlet]="wooCommerceFileNameSKUMapping"></ng-template>
                </div>
              </mat-expansion-panel>
            </div>
          </mat-expansion-panel>


          <!-- WOOCOMMERCE | EXISTING FILES | MANY FILES -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag har många motiv (fler än 50)' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <ng-template [ngTemplateOutlet]="ftpInstructions"></ng-template>
              <ng-template [ngTemplateOutlet]="wooCommerceFileNameSKUMapping"></ng-template>
            </div>
          </mat-expansion-panel>

        </div>
      </mat-expansion-panel>

      <!-- WOOCOMMERCE | ON DEMAND FILES -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Motiven skapas efter att en ny order inkommer' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div>{{ 'Detta är en funktion under utveckling. Kontakta oss på' | translate }}<a href="mailto:info@aceprintpartner.com">{{ 'info&#64;aceprintpartner.com' | translate }}</a>{{ 'för att få hjälp.' | translate }}</div>
      </mat-expansion-panel>
    </div>
  </mat-expansion-panel>

  <!-- EXTERNAL API -->
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag säljer via ett eget system (API)' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <ul>
        <li>{{ 'Ditt system kan skapa ordrar med egna tryckfiler och få uppdateringar när de trycks, skickas och levereras via vårt API.' | translate }}</li>
        <li>{{ 'Anropen autentiseras med butikens access code, som du får av ACE. Butikens ID är' | translate }} <code>{{ globals.storeSettings._id }}</code></li>
        <li><a target="_blank" href="/admin/api-documentation"><span class="material-symbols-outlined">api</span>{{ 'Läs API-dokumentationen' | translate }}</a></li>
      </ul>
    </div>
  </mat-expansion-panel>

  <!-- SKU INFO -->
  <mat-expansion-panel id="sku-examples" [expanded]="skuExamplesExpanded">
    <mat-expansion-panel-header>
      <mat-panel-title><span class="material-symbols-outlined">lightbulb</span>{{ 'Jag vill se SKU-exempel' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <ng-template [ngTemplateOutlet]="fileNameSKUExampleTable"></ng-template>
    </div>
  </mat-expansion-panel>


  <!-- TEMPLATES -->
  <ng-template #shopifyFileNameSKUMapping>{{ 'Koppla Shopify-produkten till motivet genom att se till att "Streckkod" är tom, och SKU har följande format:' | translate }}<br />
    <br />
    <i>{{ 'Produkt' | translate }}</i>_<i>{{ 'BREDD' | translate }}</i>x<i>{{ 'HÖJD' | translate }}</i>_<i>{{ 'Filnamn' | translate }}</i>
    <br />
    <i>{{ 'eller' | translate }}</i>
    <br />
    <i>{{ 'Produkt' | translate }}</i>_<i>{{ 'KLÄD-SKU' | translate }}</i>_<i>{{ 'Filnamn' | translate }}</i>
    <br />
    <br />
    <b>{{ 'Exempel:' | translate }}</b>
    <ng-template [ngTemplateOutlet]="fileNameSKUExampleTable"></ng-template>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Visa alla tillgängliga SKU:er för kläder' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <ng-template [ngTemplateOutlet]="availableClothesSKUsTable"></ng-template>
      </div>
    </mat-expansion-panel>

  </ng-template>


  <ng-template #wooCommerceFileNameSKUMapping>{{ 'Koppla WooCommerce-produkten till motivet genom att se till att Artikelnummer har följande format:' | translate }}<br />
    <br />
    <i>{{ 'Produkt' | translate }}</i>_<i>{{ 'BREDD' | translate }}</i>x<i>{{ 'HÖJD' | translate }}</i>_<i>{{ 'Filnamn' | translate }}</i>
    <br />
    <i>{{ 'eller' | translate }}</i>
    <br />
    <i>{{ 'Produkt' | translate }}</i>_<i>{{ 'KLÄD-SKU' | translate }}</i>_<i>{{ 'Filnamn' | translate }}</i>
    <br />
    <br />
    <b>{{ 'Exempel:' | translate }}</b>
    <ng-template [ngTemplateOutlet]="fileNameSKUExampleTable"></ng-template>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Visa alla tillgängliga SKU:er för kläder' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <ng-template [ngTemplateOutlet]="availableClothesSKUsTable"></ng-template>
      </div>
    </mat-expansion-panel>

  </ng-template>


  <ng-template #fileNameSKUExampleTable>
    <table class="styled fullwidth">
      <tr>
        <th>{{ 'Posters' | translate }}</th>
        <th class="align-right"></th>
      </tr>
      <tr>
        <td>{{ '50x70cm poster som använder filen motiv1.pdf' | translate }}</td>
        <th class="align-right">{{ 'POSTER_50x70_motiv1' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster som använder filen motiv2.pdf' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_motiv2' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster som använder filen motiv2.pdf med en vit (passepartout)ram på 35mm' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_B35W_motiv2' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster som använder filen motiv2.pdf med en svart (passepartout)ram på 35mm' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_B35B_motiv2' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster som använder filen motiv2.pdf och gör den svartvit' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_GREYSCALE_motiv2' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster som använder filen motiv2.pdf med en vit (passepartout)ram på 50mm, samt gör den svartvit' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_B50W&GREYSCALE_motiv2' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster som använder filen motiv2.pdf och trycks på papper med silk-finish' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_PAPERSILK_motiv2' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster som använder filen motiv2.pdf, gör den svartvit, och trycks på papper med silk-finish' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_GREYSCALE&PAPERSILK_motiv2' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '100x70cm poster där motivet inte existerar ännu(manuell uppladdning krävs)' | translate }}</td>
        <th class="align-right">{{ 'POSTER_100x70_MANUAL' | translate }}</th>
      </tr>

      <tr>
        <th></th>
        <th class="align-right"></th>
      </tr>


      <tr>
        <th>{{ 'Canvas' | translate }}</th>
        <th class="align-right"></th>
      </tr>
      <tr>
        <td>{{ '50x50cm canvastavla som använder filen motiv3.pdf' | translate }}</td>
        <th class="align-right">{{ 'CANVAS_50x50_motiv3' | translate }}</th>
      </tr>
      <tr>
        <td>{{ '50x50cm canvastavla där motivet inte existerar ännu(manuell uppladdning krävs)' | translate }}</td>
        <th class="align-right">{{ 'CANVAS_50x50_MANUAL' | translate }}</th>
      </tr>
      <tr>
        <th></th>
        <th class="align-right"></th>
      </tr>


      <tr>
        <th>{{ 'Kläder' | translate }}</th>
        <th class="align-right"></th>
      </tr>
      <tr>
        <td>{{ 'En vit T-shirt i storlek XL med motivet motiv4.png på bröstet' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_G64000-Wh-XL_F_motiv4' | translate }}</th>
      </tr>
      <!--   <tr>
        <td>{{ 'En vit T-shirt i storlek XL med motivet motiv4.png på ryggen' | translate }}</td>
        <th class="align-right">{{ 'tshirt_TS-GIL-64000-WHITE-XL_B_motiv4' | translate }}</th>
      </tr> -->
      <tr>
        <td>{{ 'En militärgrön T-shirt i storlek 2XL med motivet motiv5.png på bröstet' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_G64000-MilGr-2XL_F_motiv5' | translate }}</th>
      </tr>

      <tr>
        <td>{{ 'En militärgrön T-shirt i storlek 2XL med motivet motiv5.png på ryggen' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_G64000-MilGr-2XL_B_motiv5' | translate }}</th>
      </tr>
      <!--
      <tr>
        <td>{{ 'En militärgrön T-shirt i storlek 2XL med motivet motiv5.png på ryggen' | translate }}</td>
        <th class="align-right">{{ 'tshirt_TS-GIL-64000-MILITARY-GREEN-2XL_B_motiv5' | translate }}</th>
      </tr> -->

      <tr>
        <td>{{ 'En svart hoodie i storlek L med motivet motiv5.png på bröstet' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_JH001-Bl-L_F_motiv5' | translate }}</th>
      </tr>

      <tr>
        <td>{{ 'En svart hoodie i storlek L med motivet motiv5.png på ryggen' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_JH001-Bl-L_B_motiv5' | translate }}</th>
      </tr>

      <tr>
        <td>{{ 'En svart sweatshirt i storlek L med motivet motiv5.png på bröstet' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_JH030-Bl-L_F_motiv5' | translate }}</th>
      </tr>

      <tr>
        <td>{{ 'En svart sweatshirt i storlek L med motivet motiv5.png på ryggen' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_JH030-Bl-L_B_motiv5' | translate }}</th>
      </tr>

      <tr>
        <td>{{ 'En vit body för barn 3-6 månader med motivet motiv5.png på bröstet' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_BZ10-Wh-L_F_motiv5' | translate }}</th>
      </tr>

      <tr>
        <td>{{ 'En vit body för barn 3-6 månader med motivet motiv5.png på ryggen' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_BZ10-Wh-L_B_motiv5' | translate }}</th>
      </tr>

      <tr>
        <td>{{ 'En militärgrön T-shirt i storlek 2XLdär motivet inte existerar ännu(manuell uppladdning krävs)' | translate }}</td>
        <th class="align-right">{{ 'CLOTHES_G64000-MilGr-2XL_F_MANUAL' | translate }}</th>
      </tr>

      <tr>
        <th></th>
        <th class="align-right"></th>
      </tr>


      <tr>
        <th>{{ 'Övrigt' | translate }}</th>
        <th class="align-right"></th>
      </tr>
      <tr>
        <td>{{ 'En träram i storlek 50x70cm' | translate }}</td>
        <th class="align-right">{{ 'STOCK_FRAME_50x70_OAK' | translate }}</th>
      </tr>
      <tr>
        <td>{{ 'En svart ram i storlek 70x100cm' | translate }}</td>
        <th class="align-right">{{ 'STOCK_FRAME_70x100_BLACK' | translate }}</th>
      </tr>
      <tr>
        <td>{{ 'En studentskylt i storlek 50x70cm som använder filen motiv1.pdf' | translate }}</td>
        <th class="align-right">OTHER_STUDENT-SIGN_motiv1</th>
      </tr>
      <tr>
        <td>{{ 'En studentskylt i storlek 50x70cm där motivet inte existerar ännu(manuell uppladdning krävs)' | translate }}</td>
        <th class="align-right">OTHER_STUDENT-SIGN_MANUAL</th>
      </tr>
      <tr>
        <td>{{ 'En vit mugg som använder filen motiv1.pdf' | translate }}</td>
        <th class="align-right">OTHER_MUG-<span class="sku-variant" [matTooltip]="('Tillgängliga färger' | translate) + ': ' + mugColors.join(', ')">WHITE</span>_motiv1</th>
      </tr>
      <tr>
        <td>{{ 'En vit mugg där motivet inte existerar ännu(manuell uppladdning krävs)' | translate }}</td>
        <th class="align-right">OTHER_MUG-<span class="sku-variant" [matTooltip]="('Tillgängliga färger' | translate) + ': ' + mugColors.join(', ')">WHITE</span>_MANUAL</th>
      </tr>


    </table>
  </ng-template>

  <ng-template #availableClothesSKUsTable>
    <table class="styled">
      <tr *ngFor="let sku of availableClothesSKUs">
        <td>{{sku}}</td>
      </tr>
    </table>
  </ng-template>


  <ng-template #ftpInstructions>
    <ul>
      <li>{{ 'Säkerställ att motiven har unika filnamn, och att filnamnen ej innehåller understreck(_).' | translate }}</li>
      <li>{{ 'Kontakta oss på' | translate }}<a href="mailto:info@aceprintpartner.com">{{ 'info&#64;aceprintpartner.com' | translate }}</a>{{ 'om du inte redan har fått ett FTP-konto.' | translate }}</li>
      <li>{{ 'Ladda ner och installera en FTP-klient, exempelvis' | translate }}<a href="https://filezilla-project.org/">{{ 'FileZilla' | translate }}</a>{{ 'och ange uppgifterna som vi tillhandahåller.' | translate }}</li>
      <li>{{ 'Ladda upp dina filer. Filerna kommer att importeras automatiskt av systemet inom 10 minuter. Om det rör sig om många filer kan det dröja ett tag innan alla filer är importerade.' | translate }}</li>
    </ul>

  </ng-template>
</div>
